import { render, staticRenderFns } from "./FooterFrame.vue?vue&type=template&id=48fe9544&scoped=true"
import script from "./FooterFrame.vue?vue&type=script&lang=js"
export * from "./FooterFrame.vue?vue&type=script&lang=js"
import style0 from "./FooterFrame.vue?vue&type=style&index=0&id=48fe9544&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe9544",
  null
  
)

export default component.exports